export default __webpack_public_path__ + "static/media/rupee.2de60d12.png";